import { LeaderboardSkeleton } from '@/components/social/leaderboard/leaderboard-skeleton';
import { PodiumSkeleton } from '@/components/social/leaderboard/podium-skeleton';
import { Skeleton } from '@/components/ui/app-skeleton';
import { Panel } from '@/components/ui/panel';
import { SOCIAL_LEADERBOARD_LIST_PANEL_CLASS } from '@/lib/ui/layout';

const TAB_PILL_KEYS: readonly string[] = ['t0', 't1', 't2', 't3'];
const WINDOW_PILL_KEYS: readonly string[] = ['w0', 'w1', 'w2', 'w3', 'w4'];

// Route-level Suspense fallback for `/social`. Mirrors `SocialClient`'s
// above-the-fold layout region-for-region so the skeleton → hydrated swap is
// shape-stable: the 2-1-3 podium, the centred tab + time-window pill bars, and
// the leaderboard table. It reuses the exact `<PodiumSkeleton>` and
// `<LeaderboardSkeleton>` the live `SocialPodiumBlock` / leaderboard tabs render
// while their own data loads, so there's no second mismatched flash on hand-off.
// The default tab is the PnL leaderboard (4 metric columns).
export default function SocialLoading(): React.ReactNode {
  return (
    <div className="flex flex-col gap-6">
      <PodiumSkeleton />

      {/* Centred tab + time-window pill bars (matches the two stacked
          SegmentedControls). */}
      <div className="flex w-full flex-col items-center gap-3">
        <div className="flex items-center gap-1 rounded-pill bg-background-tertiary p-1">
          {TAB_PILL_KEYS.map((key) => (
            <Skeleton key={key} className="h-8 w-20 rounded-pill" />
          ))}
        </div>
        <div className="flex items-center gap-1 rounded-pill bg-background-tertiary p-1">
          {WINDOW_PILL_KEYS.map((key) => (
            <Skeleton key={key} className="h-8 w-14 rounded-pill" />
          ))}
        </div>
      </div>

      {/* Same Panel shell the live leaderboard tab wraps its table in, so the
          route fallback and the mounted board share padding + fill chrome. */}
      <Panel surface="solid" inheritBackground className={SOCIAL_LEADERBOARD_LIST_PANEL_CLASS}>
        <LeaderboardSkeleton columnCount={4} />
      </Panel>
    </div>
  );
}
